// extracted by mini-css-extract-plugin
module.exports = {"buttonCopy":"CopyButton_buttonCopy__2Qf3Q","iconLink":"CopyButton_iconLink__2t-5y"};